export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";